import { EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm, TableProps, Tag } from "antd";
import { MdEdit } from "react-icons/md";
import { PiTrash } from "react-icons/pi";
import { Link } from "react-router-dom";

export interface CategoryTableData {
  id: string;
  title: string;
  keywords: string[];
  articlesCount: number;
}

export const CategoryTableColumns =
  (): TableProps<CategoryTableData>["columns"] => [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (title, record) => (
        <div className="flex flex-row justify-between items-center">
          <h2>{title}</h2>
          <Link to={`/categories/edit-title/${record.id}`}>
            <MdEdit />
          </Link>
        </div>
      ),
    },
    {
      title: "Keywords",
      dataIndex: "keywords",
      key: "keywords",
      render: (keywords) => (
        <div className="flex flex-wrap gap-2">
          {keywords.map((keyword: string) => (
            <Tag color="blue" key={keyword}>
              {keyword}
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: "Articles Count",
      dataIndex: "articlesCount",
      key: "articlesCount",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex flex-row gap-2">
          <Link to={`/categories/edit-seo/${record.id}`}>
            <Button type="primary" icon={<EditOutlined />} />
          </Link>
        </div>
      ),
    },
  ];
